import EventEmitter from 'events';
import EnvironmentDetection from './EnvironmentDetection';

const sonevents = new EventEmitter();

const liveRegionMessage = {
  // special aria message component
  sendLiveRegionMessage: 'sendLiveRegionMessage',
};

const loadingFeedback = {
  start: 'loadingfeedback_start',
  stop: 'loadingfeedback_stop',
};

const prompt = {
  addToQueue: 'show-global-prompt',
  removeFromQueue: 'close-global-prompt',
};

const updateComponent = {
  refetchData: 'refetch-data',
};

const isValid = (name) => {
  if (EnvironmentDetection.isBrowser) {
    const allEvents = Object.assign(liveRegionMessage, loadingFeedback, prompt, updateComponent);
    const allValidEvents = Object.keys(allEvents).map(key => allEvents[key]);

    return allValidEvents.includes(name);
  }
  return false;
};

const Event = {
  unRegister: (name, func) => {
    sonevents.removeListener(name, func);
  },
  register: (name, func) => {
    if (isValid(name)) {
      sonevents.on(name, a => func(a));
    }
  },
  emit: (name, a) => {
    if (isValid(name)) {
      sonevents.emit(name, a);
    }
  },

  remove: (name) => {
    sonevents.removeAllListeners(name);
  },

  prompt,
  liveRegionMessage,
  loadingFeedback,
};

export default Event;
